import React from 'react';
import ChannelTypeForm from '../ChannelTypeForm'


import './channelCreate.css';

export function ChannelTypeCreate() {
    return <ChannelTypeForm isEdit={false} />;
}
